export default "__VITE_ASSET__00vQnQud__"